import { render, staticRenderFns } from "./Modification.vue?vue&type=template&id=6504e2e4&scoped=true&"
import script from "./Modification.vue?vue&type=script&lang=js&"
export * from "./Modification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504e2e4",
  null
  
)

export default component.exports